module.exports = __webpack_public_path__ + "img/image3.5698086e.jpg";